import React from 'react'
import ReactDOM, { render } from 'react-dom'
import { Router } from 'react-router'
import { Provider } from 'react-redux'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import injectTapEventPlugin from 'react-tap-event-plugin'
import moment from 'moment-jalaali'

//
// ─── IMPORT CONFIG FILES ────────────────────────────────────────────────────────
//

import routes from './routes/index'
import store, { history } from './store/configStore'
import './initialize'

//
// ─── IMPORT CSS STYLES ──────────────────────────────────────────────────────────
//

import './styles/base.scss'
import './styles/reset.css'
import './main.css'
import 'react-notifications/dist/react-notifications.css'

//
// ─── IMPORT POLLYFILL ──────────────────────────────────────────────────────────
//

import 'core-js/fn/string/includes'
import 'core-js/fn/array/includes'
import 'core-js/fn/object/keys'

// Needed for onTouchTap (by material-ui)
injectTapEventPlugin()
// general config
moment.loadPersian({ usePersianDigits: true })
const scrollToTop = () => window.scrollTo(0, 0)

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider>
      <Router history={history} routes={routes} onUpdate={scrollToTop} />
    </MuiThemeProvider>
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js